export const MAX_GUESS_WORD_LENGTH = 7;

const MIN_DICTIONARY_WORD_COUNT = 1000;

/** 2-letterwoorden ontbreken in de WoopWord-lijsten; deze vullen we zelf aan. */
const EXTRA_TWO_LETTER_WORDS = {
  nl: [
    "AA", "AD", "AH", "AI", "AL", "AM", "AN", "AS", "AT", "AU",
    "BE",
    "DA", "DE", "DO",
    "ED", "EE", "EI", "EL", "EN", "ER", "ES", "ET", "EX",
    "FA",
    "GA", "GO",
    "HA", "HE", "HI", "HO",
    "IJ", "IK", "IN", "IS",
    "JA", "JE",
    "KA", "KO",
    "LA", "LE", "LO",
    "MA", "ME", "MI", "MU",
    "NA", "NE", "NU",
    "OF", "OG", "OH", "OI", "OK", "OL", "OM", "ON", "OO", "OP", "OS", "OU",
    "PA", "PI", "PO",
    "RA", "RE", "RI", "RO",
    "SE", "SI", "SO",
    "TA", "TE", "TI", "TO",
    "UH", "UI", "UW",
    "WE", "WO",
    "ZO",
  ],
  en: [
    "AA", "AB", "AD", "AE", "AG", "AH", "AI", "AL", "AM", "AN", "AR", "AS", "AT", "AW", "AX", "AY",
    "BA", "BE", "BI", "BO", "BY",
    "DA", "DE", "DO",
    "ED", "EF", "EH", "EL", "EM", "EN", "ER", "ES", "ET", "EX",
    "FA", "FE",
    "GI", "GO",
    "HA", "HE", "HI", "HM", "HO",
    "ID", "IF", "IN", "IS", "IT",
    "JO",
    "KA", "KI",
    "LA", "LI", "LO",
    "MA", "ME", "MI", "MM", "MO", "MU", "MY",
    "NA", "NE", "NO", "NU",
    "OD", "OE", "OF", "OH", "OI", "OK", "OM", "ON", "OP", "OR", "OS", "OW", "OX", "OY",
    "PA", "PE", "PI", "PO",
    "QI",
    "RE",
    "SH", "SI", "SO",
    "TA", "TE", "TI", "TO",
    "UH", "UM", "UN", "UP", "US", "UT",
    "WE", "WO",
    "XI", "XU",
    "YA", "YE", "YO",
    "ZA",
  ],
};

const cache = { nl: null, en: null };
const loading = {};

function dictKey(lang) {
  return lang === "nl" ? "nl" : "en";
}

function getAssetBase() {
  if (typeof window !== "undefined") {
    const webpackPath = window.__webpack_public_path__;
    if (typeof webpackPath === "string" && /^https?:\/\//.test(webpackPath)) {
      return webpackPath.replace(/\/$/, "");
    }
  }
  const publicUrl = process.env.PUBLIC_URL || "";
  return publicUrl.replace(/\/$/, "");
}

function buildDictionaryUrl(lang) {
  const key = dictKey(lang);
  const base = getAssetBase();
  return base ? `${base}/dict-${key}.txt` : `/dict-${key}.txt`;
}

function parseDictionaryText(text, lang) {
  const trimmed = String(text || "").trim();
  if (!trimmed || trimmed.startsWith("<!")) {
    throw new Error("Dictionary response is not valid text");
  }
  const words = new Set(trimmed.split(",").filter(Boolean));
  if (words.size < MIN_DICTIONARY_WORD_COUNT) {
    throw new Error("Dictionary too small, likely invalid");
  }
  const extras = EXTRA_TWO_LETTER_WORDS[dictKey(lang)] || [];
  for (const word of extras) words.add(word);
  return words;
}

export function isDictionaryReady(lang) {
  const key = dictKey(lang);
  return Boolean(cache[key]);
}

export async function ensureDictionaryLoaded(lang) {
  const key = dictKey(lang);
  if (cache[key]) return cache[key];
  if (loading[key]) return loading[key];

  loading[key] = fetch(buildDictionaryUrl(lang))
    .then((response) => {
      if (!response.ok) throw new Error(`Dictionary fetch failed: ${response.status}`);
      return response.text();
    })
    .then((text) => {
      const words = parseDictionaryText(text, key);
      cache[key] = words;
      delete loading[key];
      return words;
    })
    .catch((error) => {
      delete loading[key];
      throw error;
    });

  return loading[key];
}

export function isValidWord(word, lang) {
  const key = dictKey(lang);
  const words = cache[key];
  if (!words || !word) return false;
  const normalized = String(word).toUpperCase();
  if (normalized.length > MAX_GUESS_WORD_LENGTH) return false;
  return words.has(normalized);
}
